import object from '@mailobj-browser/front/js/utils/object.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import all from '@mailobj-browser/front/js/selectors/all.js'
import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import input from '@mailobj-browser/front/js/events/types/input.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'

const format = (value, scopeJson) => {
  const json = JSON.parse(scopeJson)
  const decimals = (json.decimals) ?? 2
  const decimalSeparator = (json.decimalSeparator) ?? '.'
  const currency = (json.currency) ?? '$'
  const currencyBefore = (json.currencyBefore !== '') ? json.currencyBefore.replace('$', currency) : ''
  const currencyAfter = (json.currencyAfter !== '') ? json.currencyAfter.replace('$', currency) : ''

  const price = value / 100
  const strPrice = price.toFixed(decimals).toString().replace('.', decimalSeparator)

  return currencyBefore + strPrice + currencyAfter
}

const onInput = object(listener, {
  type: input,
  passive,
  task: (
    select
  ) => {
    const option = select.options[0]
    const form = select.closest('form')
    const { dataset } = form
    const { scopeJson } = dataset

    const dom = select.name.substring(9)
    const val = one('input[name="value_' + dom + '"]')
    const totalDom = one('span[id="id_total_' + dom + '"]')
    if (totalDom) {
      totalDom.textContent = format(val.value * option.value, scopeJson)
    }

    let total = 0
    for (const q of all('select', form)) {
      const d = q.name.substring(9)
      const v = one('input[name="value_' + d + '"]')
      total = total + (q.options[0].value * v.value)
    }

    const totalRegistrar = one('span[id="id_registrar_total"]')
    if (totalRegistrar) {
      totalRegistrar.textContent = format(total, scopeJson)
    }
  }
})

export default quantity => {
  onInput.listen(quantity)
}
